import { isEmpty } from 'lodash';
import { createSelector } from 'reselect';
import { getOpenedTaskId } from '../../general/selectors';

const DEFAULT_OBJECT = {};

const getState = (state) => state?.tasks?.tasksToProjectsRelation || DEFAULT_OBJECT;
const getTaskIdProp = (state, props) => props?.taskId;

export const getTaskProjectAndSectionLabelList = createSelector(
  [getState, getTaskIdProp],
  (state, taskId) => {
    const result = state?.[taskId];
    return isEmpty(result) ? DEFAULT_OBJECT : result;
  },
);

export const makeGetTaskProjectAndSectionLabelList = () =>
  getTaskProjectAndSectionLabelList;

const getProjectIdProp = (state, props) => props?.projectId;

export const getTaskSectionIdForProjectId = createSelector(
  [getTaskProjectAndSectionLabelList, getProjectIdProp],
  (projectAndSectionLabelList, projectId) =>
    projectAndSectionLabelList?.[projectId]?.sectionId,
);

export const makeGetTaskSectionIdForProjectId = () =>
  getTaskSectionIdForProjectId;

export const getOpenedTaskProjectAndSectionLabelList = createSelector(
  [getState, getOpenedTaskId],
  (state, taskId) => {
    const result = state?.[taskId];
    return isEmpty(result) ? DEFAULT_OBJECT : result;
  },
);

export const getTaskLastReorderTimeForProjectId = createSelector(
  [getTaskProjectAndSectionLabelList, getProjectIdProp],
  (projectAndSectionLabelList, projectId) => projectAndSectionLabelList?.[projectId]?.lastReorderTime
);
